/* eslint-disable no-unused-vars */
import axiosAuthenticated from '@/api/axios'
import router from '@/router'

const state = () => ({
  ordersList: [],
  isLoading: false
})

const getters = {
  ordersList: (state) => state.ordersList,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_ORDERS_LIST(state, payload) {
    state.ordersList = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  createPaymentOrder(
    { commit, dispatch },
    { payload, amount, product_count, fullPath }
  ) {
    commit('SET_LOADING', true)
    axiosAuthenticated
      .get('/api/users/create_payment_order', {
        params: {
          product_id: payload,
          amount,
          product_count
        }
      })
      .then(() => {
        router.push('/user')
      })
      .catch((error) => {
        dispatch('requestAuthError', { error, fullPath }, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  async fetchOrdersList({ commit }) {
    commit('SET_LOADING', true)
    try {
      const res = await axiosAuthenticated.get('/api/users/list_orders')
      commit('SET_ORDERS_LIST', res.data)
    } catch (err) {
      console.error(err)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  removeOrder(context, payload) {
    axiosAuthenticated
      .get('/api/users/remove_order', {
        params: {
          order_id: payload
        }
      })
      .then(() => {
        context.dispatch('fetchOrdersList')
      })
      .catch((err) => {
        console.log(err)
      })
  },

  detectPaymentType(_, { order_id, payment_type }) {
    axiosAuthenticated.get('/api/users/save_payment_type', {
      params: {
        order_id,
        payment_type
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
